export const FORM = 'cadastroUsuario';
